import React, { useMemo } from "react";

const sanitize = (value) => (typeof value === "string" ? value.trim() : "");

const AboutHeroSection = ({ fields }) => {
    const sanitizedData = useMemo(() => {
        if (!fields) return null;

        const heading1 = sanitize(fields.heading_1 || "");
        const heading2 = sanitize(fields.heading_2 || "");
        const description = sanitize(fields.description || "");
        const stats = Array.isArray(fields.stats)
            ? fields.stats
                .map((stat) => ({
                    number: sanitize(stat?.number || ""),
                    label: sanitize(stat?.label || ""),
                }))
                .filter((stat) => stat.number || stat.label)
            : [];

        const hasContent = heading1 || heading2 || description || stats.length > 0;
        if (!hasContent) return null;

        return { heading1, heading2, description, stats };
    }, [fields]);

    if (!sanitizedData) return null;

    const { heading1, heading2, description, stats } = sanitizedData;
    const imageUrl = fields?.background_image?.url || "";

    return (
        <section className="about_hero">
            <div className="about_hero_image">
                {imageUrl && (
                    <img 
                        src={imageUrl}
                        alt={fields?.background_image?.alt || `${heading1 || heading2 || "About"} - Hero Background`}
                        className="about_hero_bg_img"
                        fetchPriority="high"
                        loading="eager"
                    />
                )}
                <div className="container">
                    <div className="overlay-content stagger-animate" data-stagger-index="0">
                        {(heading1 || heading2) && (
                            <h1>
                                {heading1 && <span className="about-hero__line1">{heading1}</span>}
                                {heading2 && <span className="about-hero__line2">{heading2}</span>}
                            </h1>
                        )}
                        {description && <p>{description}</p>}
                    </div>
                </div>
            </div>

                {stats.length > 0 && (
                    <div className="stats-box" data-stagger-index="15">
                        {stats.map((stat, index) => (
                            <React.Fragment key={`stat-${index}`}>
                                <div className="stat-item" data-stagger-index={index + 1}>
                                    {stat.number && <p className="stat-number">{stat.number}</p>}
                                    {stat.label && <p>{stat.label}</p>}
                                </div>
                                {index < stats.length - 1 && (
                                    <div className={`divider${index === 2 ? " third" : ""}`} id={index === 2 ? "third" : undefined}></div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                )}
        </section>
    );
};

export default AboutHeroSection;

